import { PageRef } from 'providers/page-ref';

export enum NutritionTab {
  Logged = 'logged',
  Remaining = 'remaining'
}

export type NutritionPageParams = {
  day?: string;
  autoFocusElementId?: string; // if set, this will be used to scroll to the element with that id
};

export const INutritionPage: PageRef<NutritionPageParams, void> = {
  pageName: 'NutritionPage',
} as PageRef<NutritionPageParams, void>;
